<template>
  <main>
    <h1>Debug Component v.2</h1>

    <pre>
            === this.$store.state.user ===
            {{ $store.state.user }}

            === this.$store.state.healthData ===
            {{ $store.state.healthData }}

            === this.$store.state.selection ===
            {{ $store.state.selection }}

            === this.$route.path ===
            {{ $route.path }}
        </pre>
  </main>
</template>

<script>
export default {
  mounted () {
    console.log('this.$store.state.user', this.$store.state.user);
    console.log('this.$store.state.healthData', this.$store.state.healthData);
    console.log('this.$store.state.selection', this.$store.state.selection);
    console.log('this.$route', this.$route);
    console.log('this.$root', this.$root);
  },
};
</script>

<style>
    * {
        background-image: none;
    }
</style>